import React, { useContext } from 'react';
import { UserContext } from '../../contexts/UserContext';
import { Route, Redirect } from 'react-router-dom';

const PublicRoute = ({ onlyAnonymous = false, component: Component, ...rest }) => {
  const user = useContext(UserContext);
  const logged = user?.id !== undefined;
  return (
    <Route
      {...rest}
      render={(props) =>
        onlyAnonymous && logged ? (
          <Redirect to='/home' />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
